import axios from 'axios';

type TErrorResponse = {
  message?: string | string[];
  error?: string;
};

export function getNoticeExtractorErrorMessage(error: unknown) {
  if (!axios.isAxiosError<TErrorResponse>(error)) {
    return error instanceof Error ? error.message : String(error);
  }

  const message = error.response?.data?.message;
  if (Array.isArray(message)) {
    return message.join(', ');
  }

  return message ?? error.response?.data?.error ?? error.message;
}
